import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { createUseStyles } from "react-jss";

function Header() {
  const classes = useStyles();
  const { user, isAuthenticated, loginWithRedirect, logout } = useAuth0();

  const logoutWithRedirect = () =>
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });

  return (
    <div className={classes.Header}>
      {isAuthenticated ? (
        <>
          {`bonjour ${user?.name || "unkown"}`}{" "}
          <div
            className={classes.btn}
            onClick={() => logoutWithRedirect()}
            onKeyDown={() => logoutWithRedirect()}
            role="button"
            tabIndex={0}
          >
            Log out
          </div>
        </>
      ) : (
        <div
          className={classes.btn}
          onClick={() => loginWithRedirect()}
          onKeyDown={() => loginWithRedirect()}
          role="button"
          tabIndex={0}
        >
          Log in
        </div>
      )}
    </div>
  );
}

const useStyles = createUseStyles(() => ({
  Header: {
    color: "white",
    background: "#282c34",
  },
  btn: {
    cursor: "pointer",
  },
}));

export default Header;
